import * as React from 'react';
import { useEffect } from "react";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MuiInput from '@mui/material/Input';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from "dayjs";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const Input = styled(MuiInput)`
  width: 100px;
`;

const drawerBleeding = 56;

interface Props {
  window?: () => Window;
}

export default function SwipeableEdgeDrawer(props: any) {
  const { window } = props;
  const [open, setOpen] = React.useState(false);
  const [bloodValue, setBloodValue] = React.useState(props.bloodValue);


  useEffect(() => {
    setBloodValue(props.bloodValue);
  }, [props]);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;

  function handleClickSave() {
    setOpen(false);
    props.saveBlood({ type: props.bloodType, value: bloodValue });
  }

  function handleChangeValue(value: any) {
    setBloodValue(value);
  }

  function getTimeTitleForKey(key: any) {
    let title = '';

    switch (key) {
      case 'bloodSugarMorning': title = '아침 식전'; break;
      case 'bloodSugarMorningAfter': title = '아침 식후'; break;
      case 'bloodSugarLunch': title = '점심 식전'; break;
      case 'bloodSugarLunchAfter': title = '점심 식후'; break;
      case 'bloodSugarDinner': title = '저녁 식전'; break;
      case 'bloodSugarDinnerAfter': title = '저녁 식후'; break;
      case 'bloodSugarSleep': title = '취침 전'; break;
      default: title = ''; break;
    }

    return title;
  }



  return (

    <Box>


      <Typography component="div" sx={{ fontSize: 16, color: '#bbb',  }}
        onClick={toggleDrawer(true)}>
          <AddCircleOutlineIcon sx={{verticalAlign:'middle'}} /> 
      </Typography>



      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        ModalProps={{
          keepMounted: false,
        }}
        sx={{ '& .MuiDrawer-paper': { borderRadius: '20px 20px 0 0' } }}
      >
        <Box sx={{ m: 0, py: 3, px: 2 }}>
          <Stack >
            <Typography
              sx={{
                color: '#333',
                fontSize: 18,
                fontWeight: 700,
                textAlign: 'center',
                mb: '20px',
                borderBottom: '1px solid #ddd',
                pb: 2
              }}
            >
              오늘의 혈당을 입력하세요
            </Typography>
          </Stack>

          <Stack direction={'row'} spacing={2} mt={0} justifyContent={'flex-end'} sx={{ 
            '& .MuiTextField-root': { minWidth: 'auto !important' }, 
            width: '100%', 
            '& .MuiOutlinedInput-input': { bgcolor: '#fff', textAlign: 'center', py:1},
            '& div': { justifyContent: 'flex-end' }, 
            }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DemoContainer components={['MobileTimePicker']} sx={{ flex: 1, p: 0, '& .MuiOutlinedInput-notchedOutline' : {borderWidth:0}}}>
                <DemoItem label="">
                  <TextField
                    type="text"
                    placeholder={getTimeTitleForKey(props.bloodType)}
                    disabled
                    value={getTimeTitleForKey(props.bloodType)}
                    sx={{ border: 0, '& .MuiOutlinedInput-input.Mui-disabled': { '-webkitTextFillColor': '#333', fontWeight:700 } }}
                  />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>

            <DemoItem label="혈당값(mg/dL)" sx={{ flex: 1 }}>
              <TextField
                type="number"
                placeholder='혈당값 입력'
                defaultValue={props.bloodValue}
                onChange={(e) => { handleChangeValue(e.target.value) }}
              />
            </DemoItem>
          </Stack>

          <Stack sx={{ p: 0, width: '100%', boxSizing: 'border-box', }}>
            <Button onClick={handleClickSave} sx={bottomBtn}>
              저장
            </Button>
          </Stack>

        </Box>
      </SwipeableDrawer>
    </Box>
  );
}

const editbtn = {
  width: '100%',
  alignItems: 'center'
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '90%',

  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});


const bottomBtn = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 20px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  color: '#fff',
  width: '100%',
  borderRadius: '20px',
  mt: 3,
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
}
